import * as types from '../../actions/actionsTypes/giustificativiActionType';

export const initialStateGiustificativi = {
    /*numRequestSuccess: 0,
    numRequestFail: 0,
    numRequest: 0,*/
    giustificativiEnd: false,
    error: null
};

export const giustificativiReducer = (state = initialStateGiustificativi, action ) => {
    switch (action.type){

        case types.INIT_REQUEST_GIUSTIFICATIVI :
            return {
                ...state,
                /*numRequest: 0,
                numRequestSuccess: 0,
                numRequestFail: 0,*/
                giustificativiEnd: false,
                error: null
            };

        case types.ADD_GIUSTIFICATIVO_END:
            return {
                ...state,
                /*numRequest: ++state.numRequest,
                numRequestSuccess: ++state.numRequestSuccess,*/
                giustificativiEnd: true,
                error: action.errors
            };

        case types.DELETE_GIUSTIFICATIVO_SUCCESS:
            return {
                ...state,
                giustificativiEnd: true,
                error: action.errors
            };

        /*case types.ADD_GIUSTIFICATIVO_FAIL:
            return {
                ...state,
                numRequest: ++state.numRequest,
                numRequestFail: ++state.numRequestFail,
                error: Object.assign({}, state.error, {[action.nomeIndividuo]: action.error})
            };*/

        default:
            return state
    }
};
